// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDQGSgBCzr8NsIYjG_13dDZ6vZrGv-Coy0",
    authDomain: "masaleweb.firebaseapp.com",
    projectId: "masaleweb",
    storageBucket: "masaleweb.firebasestorage.app",
    messagingSenderId: "197333418141",
    appId: "1:197333418141:web:c1f156c8f4824d5ea4d474",
    measurementId: "G-J45GRBPV7Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };